import React from "react";

const Level2PictureId = ({ question, remainingSeconds, submitting, onSubmit }) => {
  const handlePick = (imageId) => {
    onSubmit({ selectedImageId: imageId });
  };

  return (
    <div className="rounded-3xl bg-white/5 border border-white/10 p-8 max-w-2xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <span className="text-xs uppercase tracking-widest text-emerald-300">
          {question.category}
        </span>
        <span className="text-2xl font-black text-yellow-300">
          ⏱ {remainingSeconds ?? "--"}s
        </span>
      </div>

      <h2 className="text-xl lg:text-2xl font-bold text-white mb-1 text-center">
        {question.payload.prompt}
      </h2>
      {question.payload.promptTranslated && (
        <h3 className="text-base lg:text-lg font-semibold text-cyan-200 mb-6 text-center">
          {question.payload.promptTranslated}
        </h3>
      )}
      {!question.payload.promptTranslated && <div className="mb-6" />}

      <div className="grid grid-cols-2 gap-4">
        {question.payload.images.map((img) => (
          <button
            key={img.id}
            onClick={() => handlePick(img.id)}
            disabled={submitting}
            className="rounded-2xl bg-white/5 border border-white/10 hover:bg-emerald-500/20 hover:border-emerald-400 transition-all py-8 flex flex-col items-center gap-2 disabled:opacity-40"
          >
            <span className="text-6xl">{img.emoji}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Level2PictureId;
